import React from "react";
import { Page, Text, View, StyleSheet, Image } from "@react-pdf/renderer";
import logo from "../../../../images/Final-logo-SBS.png"

// Newly added icons
import webIcon from "../../images/web.jpg";
import phoneIcon from "../../images/phone icon.jpg";
import locationIcon from "../../images/location icon.jpg"; // <-- add your location icon here
import messageIcon from "../../images/message.jpg";   // <-- add your message icon here

const PdfSecondPage = ({ quotation }) => (
  <Page size="A4" style={styles.page}>
    {/* Header */}
    <View style={styles.header}>
      <Image src={logo} style={styles.logo} />
      <View style={styles.headerRight}>
        <Image src={webIcon} style={styles.iconSmall} />
        <Text style={styles.website}>sbsgroups.co.in</Text>
      </View>
    </View>

    {/* Body Content - Only Quotation Body */}
    <View style={styles.body}>
      {quotation.quotation_body ? (
        <View style={styles.quotationSection}>
          {quotation.quotation_body
            .split('\n')
            .filter(line => line.trim())
            .map((line, index, array) => {
              const isSectionHeading = line.trim().endsWith(':') || 
                                     line.trim().length < 50 || 
                                     /^[A-Z\s]+$/.test(line.trim());
              
              const isNewParagraph = index > 0 && !array[index - 1].trim();
              
              return (
                <Text 
                  key={index} 
                  style={[
                    styles.quotationLine,
                    isSectionHeading && styles.quotationHeading,
                    isNewParagraph && styles.newParagraph
                  ]}
                >
                  {line.trim()}
                </Text>
              );
            })
          }
        </View>
      ) : (
        <Text style={styles.noContent}>No quotation details available.</Text>
      )}
    </View>

    {/* Footer */}
    <View style={styles.footer}>
      {/* Phone section */}
      <View style={styles.footerSection}>
        <Image src={phoneIcon} style={styles.icon} />
        <View>
          <Text style={styles.footerText}>8827559628</Text>
          <Text style={styles.footerText}>9826808412</Text>
        </View>
      </View>

      {/* Location section */}
      <View style={[styles.footerSection, styles.footerCenter]}>
        <Image src={locationIcon} style={styles.icon} />
        <Text style={styles.footerText}>
          Main Road Tali Waidhan, Near Honda Showroom, Singrauli M.P.-486886 (INDIA).
        </Text>
      </View>

      {/* Message section */}
      <View style={[styles.footerSection, styles.footerRight]}>
        <Image src={messageIcon} style={styles.icon} />
        <View>
          <Text style={styles.footerText}>info@sbsgroups.co.in</Text>
          <Text style={styles.footerText}>sales@sbsgroups.co.in</Text>
        </View>
      </View>
    </View>
  </Page>
);

const styles = StyleSheet.create({
  page: {
    padding: 25,
    fontSize: 10,
    fontFamily: "Helvetica",
    backgroundColor: "#fff",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  header: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottom: "2pt solid #b20000",
    paddingBottom: 6,
    marginBottom: 15,
  },
  logo: {
    width: 80,
    height: 80,
  },
  headerRight: {
    flexDirection: "row",
    alignItems: "center",
  },
  website: {
    fontSize: 11,
    color: "#b20000",
    fontWeight: "bold",
    marginLeft: 5,
  },
  body: {
    flexGrow: 1,
    paddingHorizontal: 20,
  },
  // Quotation Section Styles
  quotationSection: {
    marginVertical: 10,
  },
  quotationLine: {
    fontSize: 10,
    lineHeight: 1.4,
    marginBottom: 4,
  },
  quotationHeading: {
    fontWeight: "bold",
    color: "#333",
    marginTop: 6,
    marginBottom: 4,
  },
  newParagraph: {
    marginTop: 8,
  },
  noContent: {
    fontSize: 10,
    color: "#666",
    fontStyle: "italic",
    textAlign: "center",
    marginTop: 20,
  },
  footer: {
    flexDirection: "row",
    backgroundColor: "#b20000",
    color: "#fff",
    padding: 8,
    justifyContent: "space-between",
    alignItems: "center",
  },
  footerSection: {
    flexDirection: "row",
    alignItems: "center",
    width: "30%",
  },
  footerCenter: {
    width: "40%",
    textAlign: "center",
  },
  footerRight: {
    justifyContent: "flex-end",
    textAlign: "right",
  },
  footerText: {
    fontSize: 9,
    marginLeft: 4,
  },
  icon: {
    width: 30,
    height: 30,
    marginRight: 4,
  },
  iconSmall: {
    width: 30,
    height: 30,
    marginRight: 3,
  },
});


export default PdfSecondPage;
